import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=47551124"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports